module.exports = __webpack_public_path__ + "static/img/img190.b773170b.png";